var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',_vm._g(_vm._b({attrs:{"width":"100%"}},'el-dialog',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"fr"},[_c('span',{staticClass:"span"},[_vm._v("请使用浏览器的分享功能分享本文")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }